var map = {
	"../pages/admin/admin.module": [
		860,
		7
	],
	"../pages/alerts/alerts.module": [
		861,
		20
	],
	"../pages/config/config.module": [
		862,
		1
	],
	"../pages/data-list/data-list.module": [
		863,
		19
	],
	"../pages/data-pdf/data-pdf.module": [
		864,
		3
	],
	"../pages/data/data.module": [
		865,
		11
	],
	"../pages/doctor/doctor.module": [
		859,
		2
	],
	"../pages/dummy/dummy.module": [
		866,
		12
	],
	"../pages/handwechsel-modal/handwechsel-modal.module": [
		867,
		10
	],
	"../pages/help-doctor/help-doctor.module": [
		868,
		18
	],
	"../pages/help/help.module": [
		869,
		17
	],
	"../pages/info/info.module": [
		870,
		6
	],
	"../pages/login/login.module": [
		481
	],
	"../pages/overview/overview.module": [
		871,
		4
	],
	"../pages/pdf-modal/pdf-modal.module": [
		872,
		9
	],
	"../pages/pressurehistory/pressurehistory.module": [
		873,
		5
	],
	"../pages/regime-modal/regime-modal.module": [
		874,
		8
	],
	"../pages/sign-up/sign-up.module": [
		875,
		16
	],
	"../pages/tab/tab.module": [
		876,
		0
	],
	"../pages/tou/tou.module": [
		877,
		15
	],
	"../pages/ufhistory/ufhistory.module": [
		878,
		14
	],
	"../pages/weighthistory/weighthistory.module": [
		879,
		13
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 229;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 229
// module chunks = 21